import { useParams } from "react-router-dom";
import * as Styled from "./styled";
import Page from "@/components/layout/Page";
import useApi from "@/contexts/ApiContext";
import { useQuery } from "@tanstack/react-query";
import LoadingScreen from "@/components/shared-ui/LoadingScreen";
import Chevron from "@assets/icons/arrow-down.svg?react";
import DatoBlockRenderer from "@/components/shared-ui/DatoBlockRenderer";
import DocLayout from "@/components/layout/DocLayout";
import NotFound from "../NotFound";

const ProjectSummary = () => {
  const api = useApi();
  const { docSlug, sectionSlug } = useParams();
  const { data } = useQuery({
    queryKey: ["get-project-summary-docs"],
    queryFn: () => api.projectSummary.getAll(),
  });

  let currentDoc;
  let currentSection;

  if (docSlug) {
    currentDoc = data?.chapters.find((doc) => doc.slug === docSlug);
  } else {
    currentDoc = data?.chapters[0];
  }

  if (data && data.chapters.length === 0) {
    return <NotFound />;
  }

  if (!data || !currentDoc) {
    return <LoadingScreen />;
  }

  if (sectionSlug) {
    currentSection = currentDoc?.sections.find(
      (section) => section.slug === sectionSlug
    );
  } else {
    currentSection = currentDoc.sections[0];
  }

  const docsMenu = data.chapters.map((doc) => (
    <Styled.SidebarSection key={doc.id} $active={currentDoc.id === doc.id}>
      <Styled.SidebarHeadingLink
        to={`/project-summary/${doc.slug}/${doc.sections[0].slug}`}
      >
        <Chevron />
        <Styled.SidebarHeading>
          {doc.title}
          {doc.sections.some((section) => section.new) && (
            <Styled.NewTag>New</Styled.NewTag>
          )}
        </Styled.SidebarHeading>
      </Styled.SidebarHeadingLink>
      <Styled.SidebarSubSections>
        {doc.sections.map((section) => {
          return (
            <Styled.SidebarItem
              key={section.slug}
              $active={
                currentDoc.id === doc.id &&
                currentSection?.title === section.title
              }
            >
              <Styled.SidebarLink
                to={`/project-summary/${doc.slug}/${section.slug}`}
              >
                {section.title}{" "}
                {section.new && <Styled.NewTag>New</Styled.NewTag>}
              </Styled.SidebarLink>
            </Styled.SidebarItem>
          );
        })}
      </Styled.SidebarSubSections>
    </Styled.SidebarSection>
  ));

  const docContent = (
    <>{currentSection && <DatoBlockRenderer content={currentSection.content} />} </>
  );

  return (
    <Page
      title="Project Summary"
      noPadding
      fullWidth
      stickyBreadcrumbs
      whiteBackground
    >
      <DocLayout
        primarySidebar={{
          visible: true,
          menu: docsMenu,
          accordionHeading: currentDoc.title,
        }}
        secondarySidebar={{ visible: false, menu: null }}
        docHeading={currentSection ? currentSection.title : currentDoc.title}
        docContent={docContent}
      />
    </Page>
  );
};

export default ProjectSummary;
